import { ShieldCheck, Wifi } from "lucide-react";
import { Badge } from "@/components/ui/badge";

type PrivacyBadgeProps = {
  localOnly: boolean;
};

export function PrivacyBadge({ localOnly }: PrivacyBadgeProps) {
  return (
    <Badge variant={localOnly ? "success" : "warning"}>
      {localOnly ? (
        <ShieldCheck className="h-3 w-3" />
      ) : (
        <Wifi className="h-3 w-3" />
      )}
      {localOnly ? "Runs locally" : "Uses API"}
    </Badge>
  );
}
